module.exports = __webpack_public_path__ + "img/return_top.06fd93b7.png";